export default __webpack_public_path__ + "static/Colin-4857c238a9cd8f184b9d9fbba1fec5b7e9eb85a225281fec4df10bc064dc29e9.svg";